import React, { useRef, useState } from "react";
import AppLayout, {
  AppLayoutProps,
} from "@amzn/awsui-components-console/app-layout";
import { NonCancelableCustomEvent } from "@amzn/awsui-components-console";
import { useParams } from "react-router-dom";
import { Navigation } from "src/pages/commons";
import { URLS } from "src/components/constants/appConstants";
import { ToolsContent } from "src/pages/transactionSearch/components/common-components";
import AppTransactionSearch from "src/components/transactionSearchPage/transaction-search-page";
import { Domain } from "src/config/BartLambdaConfig";
import "../commons/common.styles.scss";
import { appLayoutAriaLabels } from "src/i18n-strings/app-layout";
import { useSettingsStore } from "src/stores/useSettingsStore";
import { resolveInitialPanelState } from "src/hooks/useInitialPanelState";
interface Props {
  domain: Domain;
}

export function TransactionSearch(props: Props) {
  const { type, id } = useParams();
  const { navPanelBehavior, toolsPanelBehavior } = useSettingsStore();
  const [navigationOpen, setNavigationOpen] = React.useState(
    resolveInitialPanelState(true, navPanelBehavior),
  );
  const appLayout = useRef<AppLayoutProps.Ref>(null);
  const [toolsOpen, setToolsOpen] = useState(
    resolveInitialPanelState(false, toolsPanelBehavior),
  );
  const loadPanelFn = () => {
    setToolsOpen(true);
    appLayout.current?.focusToolsClose();
  };

  const onToolsChangeFn = ({
    detail,
  }: NonCancelableCustomEvent<AppLayoutProps.ChangeDetail>) => {
    setToolsOpen(detail.open);
  };
  return (
    <AppLayout
      disableContentPaddings
      content={
        <AppTransactionSearch key={`${type}/${id}`} domain={props.domain} />
      }
      navigation={<Navigation activeHref={URLS.MAIN_PAGE} />}
      navigationOpen={navigationOpen}
      onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
      tools={<ToolsContent />}
      toolsOpen={toolsOpen}
      onToolsChange={onToolsChangeFn}
      ariaLabels={appLayoutAriaLabels}
    />
  );
}
